//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.factory("QueryService", ["$http", QueryServiceFactory]);

	function QueryServiceFactory($http) {
		return {
			queryGroups: queryGroups,
			getCiclos: getCiclos,
			getMetadata: getMetadata,
			query: query,
			queryIds: queryIds
		};

		function queryGroups() {
			return $http.get("/queries");
		}

		function getCiclos(queryName, module) {
			return $http.get("/queries/" + queryName + "/snapshots/" + module);
		}

		function getMetadata(queryName, filter) {
			var config = {
				method: "GET",
				url: "/queries/" + queryName + "/md",
				params: filter
			};
			return $http(config);
		}

		function query(queryName, fullFilter) {
			var config = {
				method: "GET",
				url: "/queries/" + queryName + "/scroll",
				params: fullFilter
			};
			return $http(config);
		}

		function queryIds(queryName, fullFilter) {
			var config = {
				method: "POST",
				url: "/queries/" + queryName + "/ids",
				params: fullFilter
			};
			return $http(config);
		}
	}
})();
